import {
  FEATURE_OVERRIDE_QUERY_KEY,
  useFeatureOverrideStorage,
} from '~/composables/ds/useFeatureVersion';

// Mémorise l'override de versions DS posé en query (`?fv=chrome:legacy`) pour le navigateur : sans
// ça, il tombe à la première navigation interne, qui perd le paramètre. `?fv=` vide l'efface.
// La validation du contenu reste dans useFeatureVersion — on ne stocke qu'une chaîne brute.
export default defineNuxtPlugin(() => {
  const router = useRouter();
  const stored = useFeatureOverrideStorage();

  const sync = (raw: unknown): void => {
    if (typeof raw !== 'string') { return; }
    stored.value = raw.trim() === '' ? null : raw;
  };

  sync(router.currentRoute.value.query[FEATURE_OVERRIDE_QUERY_KEY]);
  router.afterEach((to) => { sync(to.query[FEATURE_OVERRIDE_QUERY_KEY]); });
});
